import React, { Fragment } from "react";
import { Modal, ModalHeader, ModalBody, Card, CardBody, Row, Button, ModalFooter } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import Pagination from "./Pagination";
import moment from "moment";

const ChatLogs = ({ isOpen, toggle, chatLogs, currentPage, totalPages, onChangePage }) => {
    // if (!chatLogs || chatLogs.length === 0) {
    //     return (
    //         <Modal isOpen={isOpen} toggle={toggle} size="lg">
    //             <ModalHeader toggle={toggle}>Chat Logs</ModalHeader>
    //             <ModalBody className="text-center">
    //                 No entries available
    //             </ModalBody>
    //         </Modal>
    //     );
    // }

    // Assuming model is same for all logs
    const hasLogs = Array.isArray(chatLogs) && chatLogs.length > 0;
    const modelName = hasLogs ? chatLogs[0].model : "";

    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} style={{ maxWidth: "1000px" }}>
                <ModalHeader toggle={toggle}>Chat Logs</ModalHeader>
                <ModalBody>
                    {hasLogs ? (
                        <>
                            <h5 className="mb-4">
                                <strong>Model:</strong> {modelName}
                            </h5>

                            {chatLogs.map((entry, index) => (
                                <Row className="mb-3" key={index}>
                                    <Colxx xxs="12">
                                        <Card className="d-flex mb-3" style={{ borderRadius: "25px" }}>
                                            <CardBody className="logsBody" style={{ overflowX: "auto" }}>
                                                <Row className="mb-3">
                                                    <Colxx xxs="12" className="mb-2">
                                                        <b>Query</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="wrap-text">{entry.query}</Colxx>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Colxx xxs="12" className="mb-2">
                                                        <b>Context</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="wrap-text">{entry.context}</Colxx>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Colxx xxs="12" className="mb-2">
                                                        <b>History</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="wrap-text">{entry.history}</Colxx>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Colxx xxs="12" className="mb-2">
                                                        <b>Response</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="wrap-text">{entry.response}</Colxx>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Colxx>
                                </Row>
                            ))}
                        </>
                    ) : (
                        <div className="text-center">No entries available</div>
                    )}
                </ModalBody>
                <ModalFooter>
                    {hasLogs && (
                        <Pagination
                            currentPage={currentPage}
                            totalPage={totalPages}
                            onChangePage={(i) => onChangePage(i)}
                        />
                    )}
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ChatLogs;